const questions = [
  {
    id: 1,
    question: "She ___ watching TV when I arrived.",
    options: ["was", "were", "is"],
    answer: "was",
    concept: "past_continuous_be",
    skill: "auxiliary_be",
    explanation: "Use 'was' with he / she / it in the Past Continuous."
  },
  {
    id: 2,
    question: "Which sentence is correct?",
    options: [
      "They was playing football at 6 PM.",
      "They were playing football at 6 PM.",
      "They are playing football at 6 PM."
    ],
    answer: "They were playing football at 6 PM.",
    concept: "past_continuous_plural",
    skill: "auxiliary_be",
    explanation: "Use 'were' with plural subjects in the Past Continuous."
  },
  {
    id: 3,
    question: "I was ___ when you called me.",
    options: ["sleep", "sleeping", "slept"],
    answer: "sleeping",
    concept: "past_continuous_form",
    skill: "verb_ing_form",
    explanation: "The Past Continuous uses: was / were + verb + ing."
  },
  {
    id: 4,
    question: "Which sentence shows two actions happening in the past?",
    options: [
      "He worked while I cook.",
      "He was working while I was cooking.",
      "He is working while I cook."
    ],
    answer: "He was working while I was cooking.",
    concept: "past_continuous_parallel_actions",
    skill: "sentence_structure",
    explanation: "Use the Past Continuous for two actions happening at the same time in the past."
  },
  {
    id: 5,
    question: "Which sentence talks about an action in progress at a past time?",
    options: [
      "We had dinner yesterday.",
      "We were having dinner at that time.",
      "We have dinner every day."
    ],
    answer: "We were having dinner at that time.",
    concept: "past_continuous_usage",
    skill: "tense_usage",
    explanation: "The Past Continuous describes an action in progress at a specific time in the past."
  }
];

export default questions;


